import moment from "moment";
import { axiosClient } from "../../config/axiosConfig"

export const Chat_TYPES = {
    SET_ISLOADING: 'SET_ISLOADING',
    GET_CONVERSATIONLIST: 'GET_CONVERSATIONLIST',
    GET_CHATHISTORY: 'GET_CHATHISTORY',
    SET_CONVERSATIONID: 'SET_CONVERSATIONID',
    CREATE_CONVERSATION: 'CREATE_CONVERSATION',
    DELETE_CONVERSATION: 'DELETE_CONVERSATION',
    UPDATE_TITLE: 'UPDATE_TITLE',
    UPDATE_PIN: 'UPDATE_PIN',
    UPDATE_CONVERSATIONID: 'UPDATE_CONVERSATIONID',
    SEND_MESSAGE: 'SEND_MESSAGE',
    ADD_CONVEERSATION_HISORY: 'ADD_CONVEERSATION_HISORY',
    SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
    UPDATE_THUMB:'UPDATE_THUMB',
    GRAPH_ACCESS_TOKEN:'GRAPH_ACCESS_TOKEN'
}

export const setIsLoading = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.SET_ISLOADING,
        payload: data
    })
}

export const setGraphAccessToken = (data) =>  async (dispatch) =>{ 
    dispatch({
        type: Chat_TYPES.GRAPH_ACCESS_TOKEN,
        payload: data
    });
}

export const getConversationList = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/getall/', {
            EnvID: data
        });

        dispatch({
            type: Chat_TYPES.GET_CONVERSATIONLIST,
            payload: response
        })

    } catch (err) {

    }
}

export const createConversation = (data) => async (dispatch) => {
    try {
        // dispatch({
        //     type: Chat_TYPES.CREATE_CONVERSATION,
        //     payload: { req: data, res: '' }
        // })

        // Get conversationID
        const conID = await axiosClient.post('/api/chat/create_convo/', {
            EnvID: data.envID,
            FirstMessage: data.user_prompt
        })

        data.convoID = conID;

        dispatch({
            type: Chat_TYPES.CREATE_CONVERSATION,
            payload: { req: data, res: '' }
        })

        // Replace conversatoinID
        // await dispatch({
        //     type: Chat_TYPES.UPDATE_CONVERSATIONID,
        //     payload: { conID: conID, key: data.key }
        // })

        try {
            // Get Answer by passing Conversation, Question and UserID
            let response = await axiosClient.post('/api/chat/next_msg/', {
                EnvID: data.envID,
                ConvoID: conID,
                UserPrompt: data.user_prompt,
                IsNewTopic: true
            }
            );

            data.status = '';
            response.is_stream = true;

            dispatch({
                type: Chat_TYPES.CREATE_CONVERSATION,
                payload: { req: data, res: response }
            })
        }
        catch (err) {
            data.status = 'E';
            const answer = {
                user_prompt: data.user_prompt,
                timestamp: data.timestamp,
                bot_response: '',
                bot_timestamp: moment(),
                status: 'E'
            }

            dispatch({
                type: Chat_TYPES.CREATE_CONVERSATION,
                payload: {
                    req: data,
                    res: answer
                }
            })
        }

    } catch (err) {

    }
}

export const sendMessage = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.SEND_MESSAGE,
        payload: { req: data, res: '' }
    })

    try {
        let response = await axiosClient.post('/api/chat/next_msg/', {
            EnvID: data.envID,
            ConvoID: data.ConvoID,
            UserPrompt: data.user_prompt,
            IsNewTopic: data.isNewTopic
        }
        );

        data.status = '';
        response.is_stream = true;

        dispatch({
            type: Chat_TYPES.SEND_MESSAGE,
            payload: { req: data, res: response }
        })
    } catch (err) {
        data.status = 'E';
        dispatch({
            type: Chat_TYPES.SEND_MESSAGE,
            payload: {
                req: data,
                res: ''
            }
        })
    }

    // try {
    //     if (data.chatHistoryLength === 2) {
    //         const title = await axiosClient.post('/api/chat/title/', {
    //             ConvoID: data.ConvoID,
    //             ConvoTitle: data.user_prompt
    //         }
    //         );

    //         var newTitle = {
    //             convoID: data.ConvoID,
    //             convoTitle: title,
    //             lastUpdated: moment()
    //         }
    //         dispatch({
    //             type: Chat_TYPES.UPDATE_TITLE,
    //             payload: newTitle
    //         })
    //     }
    // } catch (err) {

    // }
}

export const sendTumbStatus = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/send_thumb/', data);
        return response;
    } catch (err) {

    }
}

export const updateTumbStatus = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.UPDATE_THUMB,
        payload: data
    })
}

export const deleteConversation = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/archive/', {
            ConvoID: data.ConvoID
        });

        dispatch({
            type: Chat_TYPES.DELETE_CONVERSATION,
            payload: data
        })

    } catch (err) {

    }
}

export const updateTitle = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/title/', {
            ConvoID: data.convoID,
            ConvoTitle: data.convoTitle
        });


        dispatch({
            type: Chat_TYPES.UPDATE_TITLE,
            payload: data
        })


    } catch (err) {

    }
}

export const getChatHistory = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/getone/', {
            ConvoID: data.ConvoID
        });

        dispatch({
            type: Chat_TYPES.GET_CHATHISTORY,
            payload: {
                chatHistory: response.chat_history
            }
        })

    } catch (err) {
        dispatch({
            type: Chat_TYPES.SET_ISLOADING,
            payload: false
        })
    }
}

export const updatePin = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/set-conversation-pin/', {
            ConvoID: data.convoID,
            PinValue: data.pinValue
        });


        dispatch({
            type: Chat_TYPES.UPDATE_PIN,
            payload: data
        })


    } catch (err) {

    }
}

export const setConversationID = (data) => async (dispatch) => {
    try {
        dispatch({
            type: Chat_TYPES.SET_CONVERSATIONID,
            payload: data
        })

    } catch (err) {

    }
}

export const addConversationHistory = (data) => async (dispatch) => {
    try {
        dispatch({
            type: Chat_TYPES.ADD_CONVEERSATION_HISORY,
            payload: data
        })


    } catch (err) {

    }
}

export const submitFeedback = (data) => async (dispatch) => {
    await axiosClient.post('/api/chat/feedback/', data);
}

export const ResetStream = () => async (dispatch) => {
    try {
        dispatch({
            type: Chat_TYPES.RESET_STREAM,
            payload: false
        })
    } catch (err) {

    }
}